<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Unidade</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="entity.unit_name"
                        placeholder=""
                      />
                    </div>

                    <div class="form-group col-md-2">
                      <label for="Name">
                        <span class="required">*</span> CEP:
                      </label>
                      <input
                        autocomplete="new-password"
                        id="Name"
                        v-model="entity.zip_code"
                        placeholder=""
                        type="tel"
                        class="form-control"
                        v-on:keyup="buscar"
                        v-mask="'99999-999'"
                      />
                    </div>

                    <div class="form-group col-md-6">
                      <label for="address">
                        <span class="required">*</span> Endereço:
                      </label>
                      <div class="position-relative">
                        <input
                          type="text"
                          id="address"
                          class="form-control"
                          v-model="entity.address"
                          @input="onInputEndereco"
                          placeholder="Digite o endereço..."
                        />
                        <ul
                          v-if="sugestoes_endereco.length > 0"
                          class="list-group position-absolute w-100"
                          style="z-index: 1000; max-height: 200px; overflow-y: auto;"
                        >
                          <li
                            v-for="(sugestao, index) in sugestoes_endereco"
                            :key="index"
                            class="list-group-item list-group-item-action"
                            style="cursor: pointer;"
                            @click="onSelectEndereco(sugestao)"
                          >
                            {{ sugestao.description }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="Name">
                        <span class="required">*</span> Número:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="number"
                        class="form-control"
                        v-model="entity.number"
                        placeholder=""
                        id="inputnumber"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Name">
                        <span class="required">*</span> Bairro:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="entity.neighborhood"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name"> Complemento: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="entity.complement"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name"> Ponto de Referência: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="entity.reference_point"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="Name"> Telefone: </label>
                      <input
                        autocomplete="new-password"
                        type="tel"
                        id="Name"
                        class="form-control"
                        v-model="entity.phone"
                        placeholder=""
                        v-mask="'(99) 99999-9999'"
                      />
                    </div>

                    <div class="form-group col-md-4">
                      <label for="Name"> CNES: </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="entity.cnes"
                        placeholder=""
                      />
                    </div>

                    <div class="form-group col-md-5">
                      <label for="Name">
                        <span class="required">*</span> Situação da unidade:
                      </label>
                      <select v-model="entity.status" class="form-control">
                        <option :value="1">Ativo</option>
                        <option :value="0">Inativo</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label><span class="required">*</span> Agência</label>
                      <v-select
                        v-model="entity.centrals"
                        class="vselect"
                        :options="centrals"
                        :reduce="(centrals) => centrals.id"
                        :label="'fantasy_name'"
                        multiple
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label><span class="required">*</span> Estado</label>
                      <input
                        v-model="entity.state"
                        type="text"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label><span class="required">*</span> Cidade</label>
                      <input
                        v-model="entity.city"
                        type="text"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label>Latitude</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="entity.latitude"
                        placeholder="Ex: -23.5505"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label>Longitude</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="entity.longitude"
                        placeholder="Ex: -46.6333"
                      />
                    </div>
                  </div>

                  <div v-if="entity.latitude && entity.longitude" class="form-row mb-3">
                    <div class="col-md-12">
                      <label>Localização no mapa</label>
                      <iframe
                        :src="`https://maps.google.com/maps?q=${entity.latitude},${entity.longitude}&hl=pt-BR&z=16&output=embed`"
                        width="100%"
                        height="300"
                        style="border: 1px solid #ced4da; border-radius: .25rem; display: block;"
                        scrolling="no"
                        loading="lazy"
                      ></iframe>
                      <a
                        :href="`https://www.google.com/maps?q=${entity.latitude},${entity.longitude}`"
                        target="_blank"
                        class="btn btn-sm btn-outline-secondary mt-1"
                      >
                        Abrir no Google Maps
                      </a>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="card">
                    <div class="card-header">Vínculos</div>
                    <div class="card-body">
                      <div class="row" v-if="entity.id">
                        <div class="col-md-12 text-right mb-2">
                          <button
                            class="btn btn-primary"
                            data-toggle="modal"
                            data-target="#newLink"
                          >
                            Adicionar
                          </button>
                        </div>
                        <div class="col-md-12">
                          <table class="table">
                            <tr>
                              <th scope="col" style="width: 30%">Tipo</th>
                              <th scope="col" style="width: 30%">Motivo</th>
                              <th scope="col" style="width: 30%">Convênio</th>
                              <th scope="col" style="width: 10%">Ações</th>
                            </tr>
                            <tr
                              v-for="(link, index) in entity.links"
                              :key="index"
                            >
                              <td style="width: 30%">{{ link.type.title }}</td>
                              <td style="width: 30%">
                                {{ link.reason.title }}
                              </td>
                              <td style="width: 30%">
                                {{ link.medical_agreement.title }}
                              </td>
                              <td style="width: 10%">
                                <button
                                  class="btn btn-crud delete"
                                  @click="removeLink(index)"
                                >
                                  <i class="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                            <!-- <tr v-if="entity.links.length == 0">
                              <td colspan="4" align="center">
                                Nenhum cadastrado
                              </td>
                            </tr> -->
                          </table>
                        </div>
                      </div>
                      <div class="row" v-else>
                        <div class="col-md-12">
                          <div class="alert alert-danger" role="alert">
                            Para realizar os vínculos, você precisa primeiro
                            adicionar esta unidade, em seguida realizar uma
                            edição.
                          </div>
                        </div>
                      </div>
                      <!-- <div class="row" v-else>
                        <div class="col-md-12">
                          <div class="alert alert-danger" role="alert">
                            Para realizar os vínculos, você precisa primeiro
                            adicionar este convênio, em seguida realizar uma
                            edição.
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="block text-right">
                    <router-link to="/units" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="newLink"
      tabindex="-1"
      role="dialog"
      aria-labelledby="newLinkTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Novo Vínculo</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <label>Tipo</label>
                <v-select
                  v-model="new_link.type_id"
                  class="vselect"
                  :options="types"
                  :reduce="(types) => types.id"
                  :label="'title'"
                />
              </div>
              <div class="col-md-4">
                <label>Motivo</label>
                <v-select
                  v-model="new_link.reason_id"
                  class="vselect"
                  :options="reasons"
                  :reduce="(reasons) => reasons.id"
                  :label="'title'"
                />
              </div>
              <div class="col-md-4">
                <label>Convênio</label>
                <v-select
                  v-model="new_link.medical_agreement_id"
                  class="vselect"
                  :options="medical_agreements"
                  :reduce="(medical_agreements) => medical_agreements.id"
                  :label="'title'"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button type="button" class="btn btn-primary" @click="addLink">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import env from "../../config/env";

export default {
  data() {
    return {
      new_link: {
        type_id: null,
        reason_id: null,
        medical_agreement_id: null,
      },
      entity: {
        unit_name: "",
        address: "",
        neighborhood: "",
        complement: "",
        zip_code: "",
        reference_point: "",
        phone: "",
        cnes: "",
        status: "1",
        number: "",
        city: "",
        state: "",
        latitude: "",
        longitude: "",
        links: [],
        centrals: [],
      },
      centrals: [],
      types: [],
      reasons: [],
      medical_agreements: [],
      sugestoes_endereco: [],
    };
  },
  computed: {},
  watch: {
    'entity.number': function (val) {
      const self = this;
      if (!val || !self.entity.address) return;
      clearTimeout(self._numberDebounce);
      self._numberDebounce = setTimeout(() => {
        self.geocodeEnderecoCompleto();
      }, 800);
    },
  },
  methods: {
    removeLink(index) {
      const self = this;

      if (!self.entity.id) {
        self.entity.links.splice(index, 1);
      } else {
        let api =
          self.$store.state.api +
          "medical_agreement_units/" +
          self.entity.links[index].id;

        axios
          .delete(api)
          .then((response) => {
            self.$message("Sucesso", `Plano removido com sucesso`, "success");

            self.getEntity(self.entity.id);
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      }
    },
    addLink() {
      const self = this;

      if (
        !self.new_link.type_id ||
        !self.new_link.reason_id ||
        !self.new_link.medical_agreement_id
      ) {
        self.$message("Ops!", `Você precisa preencher todos os dados`, "error");
        return;
      }

      if (!self.entity.id) {
        self.entity.links.push(self.new_link);
      } else {
        let api = self.$store.state.api + "medical_agreement_units";

        self.new_link.unit_id = self.entity.id;

        axios
          .post(api, self.new_link)
          .then((response) => {
            self.$message("Sucesso", `Plano incluído com sucesso`, "success");

            self.getEntity(self.entity.id);
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      }

      self.new_link = {
        code: null,
        title: null,
      };

      $("#newLink").modal("hide");
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "units";

      if (self.entity.id) {
        self.entity._method = "PUT";
        api += "/" + self.entity.id;
      }

      axios
        .post(api, self.entity)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/units");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getMedicalAgreements: function () {
      const self = this;
      const api = self.$store.state.api + "medical-agreements?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.medical_agreements = response.data.data.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTypes: function () {
      const self = this;
      const api = self.$store.state.api + "types?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.types = response.data.data.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getReasons: function () {
      const self = this;
      const api = self.$store.state.api + "reasons?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.reasons = response.data.data.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEntity: function (id) {
      const self = this;
      const api = self.$store.state.api + "units/" + id + "?&with[]=links";

      axios
        .get(api)
        .then((response) => {
          self.entity = response.data.data[0];

          if (!self.entity.latitude && !self.entity.longitude &&
               self.entity.address && self.entity.number) {
            self.geocodeEnderecoCompleto();
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(self.entity.zip_code)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + self.entity.zip_code + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputnumber").focus();
              self.naoLocalizado = true;
              return;
            }

            self.entity.address = endereco.logradouro;
            self.entity.neighborhood = endereco.bairro;
            self.entity.complement = endereco.complemento;
            self.entity.state = endereco.uf;
            self.entity.city = endereco.localidade;

            $("#inputnumber").focus();

            const fullAddress = `${endereco.logradouro}, ${endereco.bairro}, ${endereco.localidade} - ${endereco.uf}, Brasil`;
            self.geocode(fullAddress);
          }
        );
      }
    },
    geocodeEnderecoCompleto: function () {
      const self = this;
      if (!self.entity.address || !self.entity.number) return;

      const fullAddress = `${self.entity.address}, ${self.entity.number}, ${self.entity.neighborhood}, ${self.entity.city} - ${self.entity.state}, Brasil`;
      self.geocode(fullAddress);
    },
    geocode: function (address) {
      const self = this;
      const api  = self.$store.state.api + "geocode";

      axios
        .post(api, { address })
        .then((response) => {
          self.entity.latitude  = response.data.latitude;
          self.entity.longitude = response.data.longitude;
        })
        .catch(() => {});
    },
    initAutocomplete: function () {
      const self        = this;
      const dummyDiv    = document.createElement('div');
      self._autocompleteService = new window.google.maps.places.AutocompleteService();
      self._placesService       = new window.google.maps.places.PlacesService(dummyDiv);
    },
    onInputEndereco: function () {
      const self = this;

      if (!self.entity.address || self.entity.address.length < 3) {
        self.sugestoes_endereco = [];
        return;
      }

      if (!self._autocompleteService) return;

      self._autocompleteService.getPlacePredictions(
        { input: self.entity.address, types: ['address'], componentRestrictions: { country: 'br' } },
        (predictions, status) => {
          if (status !== window.google.maps.places.PlacesServiceStatus.OK || !predictions) {
            self.sugestoes_endereco = [];
            return;
          }
          self.sugestoes_endereco = predictions;
        }
      );
    },
    onSelectEndereco: function (sugestao) {
      const self = this;
      self.sugestoes_endereco  = [];
      self.entity.address      = sugestao.description;

      self._placesService.getDetails(
        { placeId: sugestao.place_id, fields: ['address_components', 'geometry'] },
        (place, status) => {
          if (status !== window.google.maps.places.PlacesServiceStatus.OK) return;

          const get = (type, nameType = 'long_name') => {
            const component = (place.address_components || []).find(c => c.types.includes(type));
            return component ? component[nameType] : '';
          };

          self.entity.address      = get('route');
          self.entity.number       = get('street_number');
          self.entity.neighborhood = get('sublocality_level_1') || get('neighborhood');
          self.entity.city         = get('administrative_area_level_2');
          self.entity.state        = get('administrative_area_level_1', 'short_name');
          self.entity.zip_code     = get('postal_code').replace(/^(\d{5})(\d{3})$/, '$1-$2');
          self.entity.latitude     = place.geometry.location.lat();
          self.entity.longitude    = place.geometry.location.lng();
        }
      );
    },
    loadGoogleMapsScript: function () {
      return new Promise((resolve) => {
        if (window.google && window.google.maps) {
          resolve();
          return;
        }
        const script    = document.createElement('script');
        script.src      = `https://maps.googleapis.com/maps/api/js?key=${env.googleApiKey}&libraries=places`;
        script.async    = true;
        script.defer    = true;
        script.onload   = resolve;
        document.head.appendChild(script);
      });
    },
    getCentrals: function (id) {
      const self = this;
      const api = self.$store.state.api + "centrals?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.centrals = response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getCentrals();
    self.getTypes();
    self.getReasons();
    self.getMedicalAgreements();

    self.loadGoogleMapsScript().then(() => {
      self.initAutocomplete();
    });

    if (id) {
      self.getEntity(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
